import { useTheme } from "next-themes";
import { Toaster as Sonner, toast } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-white dark:group-[.toaster]:bg-black/80 group-[.toaster]:backdrop-blur-xl group-[.toaster]:text-slate-900 dark:group-[.toaster]:text-white group-[.toaster]:border-slate-200 dark:group-[.toaster]:border-white/10 group-[.toaster]:shadow-2xl group-[.toaster]:rounded-2xl",
          description: "group-[.toast]:text-slate-500 dark:group-[.toast]:text-white/60",
          actionButton: "group-[.toast]:bg-[#3BB77E] group-[.toast]:text-white",
          cancelButton: "group-[.toast]:bg-slate-100 dark:group-[.toast]:bg-white/10 group-[.toast]:text-slate-500 dark:group-[.toast]:text-white",
          error: "group-[.toaster]:bg-red-50 dark:group-[.toaster]:bg-red-500/20 group-[.toaster]:text-red-700 dark:group-[.toaster]:text-red-200 group-[.toaster]:border-red-200 dark:group-[.toaster]:border-red-500/30",
          success: "group-[.toaster]:bg-emerald-50 dark:group-[.toaster]:bg-emerald-500/20 group-[.toaster]:text-emerald-700 dark:group-[.toaster]:text-emerald-200 group-[.toaster]:border-emerald-200 dark:group-[.toaster]:border-emerald-500/30",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
